import { openPageInNewTab } from '../helpers/navigatePage';
import { MessageTypes } from '../constants/MessageTypes';
import { onDomReady } from '../helpers/onDomReady';
const NAVIGATION_PROXIED_ATTRIBUTE = 'data-container-navigation-controller';

// We don't want people to navigate within iframe so we override anchor tags and post href to main parent for navigation.
// doesn't pick up newly added hrefs or navigation due to js.

function getAnchorTags() {
  return Array.from(document.getElementsByTagName('a'));
}
function isValidHttpUrl(href) {
  let url;
  try {
    url = new URL(href);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:' || url.protocol === 'tel:' || url.protocol === 'mailto:';
}
export class ContainerNavigationController {
  constructor({
    applicationController
  }) {
    this.overrideAnchorTags = () => {
      const observer = new MutationObserver(() => {
        const anchorTags = getAnchorTags();
        anchorTags.forEach(anchorElement => {
          if (!anchorElement.hasAttribute(NAVIGATION_PROXIED_ATTRIBUTE)) {
            anchorElement.setAttribute(NAVIGATION_PROXIED_ATTRIBUTE, 'true');
            anchorElement.addEventListener('click', this.handleAnchorClick);
          }
        });
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Call it once to catch all anchor tags present at the time of page load
      const anchorTags = getAnchorTags();
      anchorTags.forEach(anchorElement => {
        anchorElement.setAttribute(NAVIGATION_PROXIED_ATTRIBUTE, 'true');
        anchorElement.addEventListener('click', this.handleAnchorClick);
      });
    };
    this.handleAnchorClick = event => {
      event.preventDefault();
      if (!event.target) {
        return;
      }
      const anchor = event.currentTarget;
      const shouldNavigate = isValidHttpUrl(anchor.href);
      this.applicationController.onLinkClick(anchor);
      if (!shouldNavigate) {
        return;
      }
      const openNewTab = anchor.target === '_blank' || anchor.target === 'blank';
      this.navigatePage(anchor.href, openNewTab);
    };
    this.applicationController = applicationController;
    onDomReady(this.overrideAnchorTags);
  }
  navigatePage(url, openNewTab = false) {
    if (openNewTab) {
      openPageInNewTab(url);
    }
    this.applicationController.sendMessage({
      type: MessageTypes.NAVIGATE_PAGE,
      payload: {
        url,
        openNewTab
      }
    });
  }
}